<template>
    <div class="break-normal text-base">
        <p v-if="canBeGlazed">
            Before selecting your colors determine if your project needs to be food safe. If so always use Glaze paints, if not Acrylics are fine. For dry brush techniques use Acrylics
            only. See
            <a
                class="text-turquoise-500 hover:text-turquoise-700"
                :href="route('studio.blog.post', { studioSlug: 'columbus-oh', post: 'acrylics-vs-glaze-on-a-ceramic-piece' })"
                title="Acrylics vs Glaze on a Ceramic piece"
                target="_blank"
                >this blog post</a
            >
            for more information about Acrylics vs Glaze.
        </p>
        <p class="mt-2">After selecting the colors you want to use, click 'Save'.</p>
        <slot></slot>
        <transition-group name="slide" tag="div">
            <div v-if="canBeGlazed" key="picker" class="my-4 flex items-center">
                <h6
                    class="my-0 mr-4 p-2"
                    :class="{
                        'cursor-pointer text-watermelon-500': selectedPaintType() === null,
                        'bg-watermelon-100': selectedPaintType() === null && paintType === 'acrylic',
                        'bg-white text-gray-300': selectedPaintType() === 'glaze',
                        'bg-white text-green-500': selectedPaintType() === 'acrylic',
                    }"
                    @click="selectPaintType('acrylic')"
                >
                    Acrylic (not food safe)
                </h6>
                <h6
                    class="my-0 ml-4 p-2"
                    :class="{
                        'cursor-pointer text-watermelon-500': selectedPaintType() === null,
                        'bg-watermelon-100': selectedPaintType() === null && paintType === 'glaze',
                        'bg-white text-gray-300': selectedPaintType() === 'acrylic',
                        'bg-white text-green-500': selectedPaintType() === 'glaze',
                    }"
                    @click="selectPaintType('glaze')"
                >
                    Glaze (food safe)
                </h6>
            </div>
            <div v-if="paintType === 'acrylic'" key="acrylic-content" class="grid grid-cols-2 gap-4 lg:grid-cols-5">
                <div
                    v-for="acrylic in colors.acrylic"
                    :key="`acrylic-${acrylic.id}`"
                    class="cursor-pointer break-normal p-2 text-center"
                    :class="{ 'shadow-lg turquoise': value.includes(acrylic.id) }"
                    @click="toggleColor(acrylic)"
                >
                    <img
                        v-if="acrylic.photo.id"
                        :src="acrylic.photo.thumb"
                        :srcset="acrylic.photo.srcset"
                        :alt="acrylic.name"
                        :title="acrylic.name"
                        loading="lazy"
                        class="max-h-64 object-scale-down"
                        width="200px"
                    />
                    <default-photo v-else type="product" :alt="acrylic.name"></default-photo>
                    <br />{{ acrylic.name }}
                </div>
            </div>
            <div v-if="paintType === 'glaze'" key="glaze-content" class="grid grid-cols-2 gap-4 lg:grid-cols-5">
                <div
                    v-for="glaze in colors.glaze"
                    :key="`glaze-${glaze.id}`"
                    class="cursor-pointer break-normal p-2 text-center"
                    :class="{ 'shadow-lg turquoise': value.includes(glaze.id) }"
                    @click="toggleColor(glaze)"
                >
                    <img
                        v-if="glaze.photo.id"
                        :src="glaze.photo.thumb"
                        :srcset="glaze.photo.srcset"
                        :alt="glaze.name"
                        :title="glaze.name"
                        loading="lazy"
                        class="max-h-64 object-scale-down"
                        width="200px"
                    />
                    <default-photo v-else type="product" :alt="glaze.name"></default-photo>
                    <br />{{ glaze.name }}
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import DefaultPhoto from '@/components/DefaultPhoto.vue';

    export default {
        name: 'PaintColors',
        components: {
            DefaultPhoto,
        },
        props: {
            value: {
                required: true,
                type: Array,
            },
            colors: {
                required: true,
                type: Object,
            },
            category: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                selectedColors: [],
                paintType: 'acrylic',
            };
        },
        computed: {
            canBeGlazed() {
                return ['Ceramics', 'Clay'].includes(this.category);
            },
        },
        created() {
            this.selectedColors = [...this.value];

            this.paintType = !this.canBeGlazed ? 'acrylic' : this.selectedPaintType();
        },
        methods: {
            selectedPaintType() {
                const acrylic = this.colors.acrylic.find((a) => a.id === this.selectedColors[0]);

                if (acrylic) {
                    return 'acrylic';
                }

                const glaze = this.colors.glaze.find((c) => c.id === this.selectedColors[0]);

                if (glaze) {
                    return 'glaze';
                }

                return null;
            },
            selectPaintType(type) {
                if (this.selectedPaintType() !== null) {
                    return;
                }

                this.paintType = this.paintType === type ? null : type;
            },
            toggleColor(color) {
                const index = this.selectedColors.indexOf(color.id);
                if (index !== -1) {
                    this.selectedColors.splice(index, 1);
                } else {
                    this.selectedColors.push(color.id);
                }

                this.$nextTick(() => {
                    this.$emit('input', this.selectedColors);
                });
            },
        },
    };
</script>
